import styled from 'styled-components';

import { mediaTablet } from 'utils/styles/responsive';

interface WrapperProps {}

export const Wrapper = styled.div<WrapperProps>`
  width: 100vw;

  position: sticky;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 28px 0;

  ${mediaTablet(`
    padding: 32px 25px;
    justify-content: space-between;
  `)};
`;

export const FilterContainer = styled.div`
  margin-right: 16px;
`;
